import { FiUpload } from 'react-icons/fi'

import {
  Button as DarkButton,
  DarkProvider,
  PaperClipIcon,
} from '@hivewatch/dark'
import type { ColorScheme } from '@hivewatch/dark'

import { Button } from '@/components/ui'

import { ButtonIProps } from '../Button/Button'

interface FileAttachButtonIProps {
  /**
   * Rebrand: renders the design-system button instead of the legacy gradient
   * one. Omit to keep the legacy appearance untouched. Only pass it from a
   * surface that sits inside a `DarkProvider` (the dark `Modal` supplies one).
   */
  colorScheme?: ColorScheme
  attachButtonTextColor?: string
  placeholder?: string
  onFileAttach: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
  variant?: ButtonIProps['variant']
  isDisabled?: boolean
}

export const FileAttachButton = ({
  colorScheme,
  attachButtonTextColor,
  placeholder,
  onFileAttach,
  variant,
  isDisabled = false,
}: FileAttachButtonIProps) => {
  if (colorScheme) {
    return (
      <DarkProvider colorScheme={colorScheme}>
        <DarkButton
          aria-label={placeholder}
          color={attachButtonTextColor}
          colorScheme={colorScheme}
          disabled={isDisabled}
          leftIcon={
            <PaperClipIcon
              color={attachButtonTextColor}
              colorScheme={colorScheme}
              size={18}
            />
          }
          onClick={onFileAttach}
          style={{ width: '100%' }}
          variant='tertiary'
        >
          {placeholder}
        </DarkButton>
      </DarkProvider>
    )
  }

  return (
    <Button
      isDisabled={isDisabled}
      leftIcon={<FiUpload size={24} />}
      onClick={onFileAttach}
      variant={variant}
      width='100%'
    >
      {placeholder}
    </Button>
  )
}
